import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import {
  ITransactionSearchState,
  TransactionSearchContext,
} from 'src/common/interfaces/states/ITransactionSearchState';
import moment from 'moment';

const initialState: ITransactionSearchState = {
  dateRange: {
    startDate: new Date(),
    endDate: new Date(),
  },
  pageNumber: 0,
  pageSize: 30,
  searchContext: TransactionSearchContext.TBR,
};

class TransactionSearchReducer extends ImmerReducer<ITransactionSearchState> {
  public setSearchParam(searchParam: Partial<ITransactionSearchState>): void {
    // react date range picker only handles dates, but we need to manipulate times
    let finalEndDate = this.draftState.dateRange.endDate;
    let finalStartDate = this.draftState.dateRange.startDate;

    // did user choose same startDate & endDate from calendar, if so make endDate with the real time
    if (searchParam.dateRange) {
      if (searchParam.dateRange?.startDate.getTime() === searchParam.dateRange?.endDate.getTime()) {
        finalEndDate = new Date();
      } else {
        finalEndDate = searchParam.dateRange?.endDate;
      }

      const timeMidnight = ` 00:00`;

      const newStartDateMoment = moment(
        `${searchParam.dateRange?.startDate
          .toISOString()
          .split('T')
          .shift()}${timeMidnight}`,
      );

      finalStartDate = newStartDateMoment.isValid()
        ? newStartDateMoment.toDate()
        : this.draftState.dateRange.startDate;
    }

    const searchParamsWithValidTimes = {
      ...searchParam,
      dateRange: {
        startDate: finalStartDate,
        endDate: finalEndDate,
      },
    };

    this.draftState = {
      ...this.draftState,
      ...searchParamsWithValidTimes,
    };
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const TransactionSearchActions = createActionCreators(TransactionSearchReducer);
export const TransactionSearchReducerFunction = createReducerFunction(
  TransactionSearchReducer,
  initialState,
);
